import { render, staticRenderFns } from "./BussinesAndGateway.vue?vue&type=template&id=74256ab1"
import script from "./BussinesAndGateway.vue?vue&type=script&lang=js"
export * from "./BussinesAndGateway.vue?vue&type=script&lang=js"
import style0 from "./BussinesAndGateway.vue?vue&type=style&index=0&id=74256ab1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports